import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles/index.scss';
import 'bootstrap/dist/js/bootstrap.min.js';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.Fragment>
    <GoogleReCaptchaProvider reCaptchaKey="6Lf5tOIqAAAAADCA0ZCGKkY8guTgCds0MEUIyqGz">
      <App />
    </GoogleReCaptchaProvider>
  </React.Fragment>
);
